import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-update-firmware-details',
  templateUrl: './update-firmware-details.component.html',
  styleUrls: ['./update-firmware-details.component.scss'],
})
export class UpdateFirmwareDetailsComponent {
  constructor(public dialogRef: MatDialogRef<UpdateFirmwareDetailsComponent>) {}

  /**
   * @description close modal by the help of dialgue reference
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }
}
